import { StateSchema } from '../../../../app/providers/StoreProvider'

export const getPageContentIsLoading = (state: StateSchema) =>
    state.pageContent.isLoading

export const getPageContentContact = (state: StateSchema) =>
    state.pageContent.contact

export const getPageContentAbout = (state: StateSchema) => state.pageContent.about

export const getPageContentFeatures = (state: StateSchema) =>
    state.pageContent.features

export const getPageContentDetails = (state: StateSchema) =>
    state.pageContent.details

export const getPageContentPrice = (state: StateSchema) => state.pageContent.price

export const getPageContentGallery = (state: StateSchema) =>
    state.pageContent.gallery

export const getPageContentBenefits = (state: StateSchema) =>
    state.pageContent.benefits
